module.exports = __webpack_public_path__ + "static/img/noresult.cb1929c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/noresult.png
// module id = ucCa
// module chunks = 97